/**
 * OPP COPY&PAY (wpwl): must call unload before removing scripts or unmounting
 * the form, or delegated handlers throw (e.g. disableBrandDetection on undefined).
 * @see https://docs.oppwa.com/integrations/widget/advanced-options — Unload/Reload
 */

declare global {
  interface Window {
    wpwl?: { unload?: () => void };
    wpwlOptions?: Record<string, unknown>;
  }
}

export function unloadHyperPayWidget(): void {
  try {
    window.wpwl?.unload?.();
  } catch {
    // ignore — widget may already be torn down
  }
  document
    .querySelectorAll<HTMLScriptElement>('script[src*="paymentWidgets.js"]')
    .forEach((el) => el.remove());
  document
    .querySelectorAll<HTMLScriptElement>('script[src*="oppwa.com/v1/static"]')
    .forEach((el) => el.remove());
  window.wpwl = undefined;
  window.wpwlOptions = {};
}

export function mergeWpwlOptions(partial: Record<string, unknown>): void {
  const prev =
    typeof window.wpwlOptions === "object" && window.wpwlOptions !== null
      ? window.wpwlOptions
      : {};
  window.wpwlOptions = { ...prev, ...partial };
}

/**
 * Must run immediately before appending `paymentWidgets.js`.
 * Use a fresh object (never merge) so stale callbacks from HMR / prior sessions
 * cannot break OPP handlers (e.g. onChangeBrand → validateInput). Always unload
 * before reload; keep brandDetection false if brand-dropdown issues reappear.
 */
export function primeWpwlOptionsForCardForm(): void {
  window.wpwlOptions = {
    // Widget picks VISA/MASTER/MADA from the card number (data-brands lists all three).
    brandDetection: true,
    // Default true — validates CVV, expiry, etc. (see Widget API: validation, allowEmptyCvv)
    validation: true,
    allowEmptyCvv: false,
    // HyperPay: full-page 3DS redirect instead of inside the modal iframe.
    paymentTarget: "_top",
  };
}
